/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Decks_Player_DeckInputs */



/**
* | output |
* | --- |
* | "{name}'s Deck" |
*
* @param {Decks_Player_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_player_deck = /** @type {((inputs: Decks_Player_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Player_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Deck di ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.name}'s Deck`)
});